import { render, staticRenderFns } from "./IntentExamplesHeaderBulkDelete.vue?vue&type=template&id=650af0d2&"
import script from "./IntentExamplesHeaderBulkDelete.vue?vue&type=script&lang=js&"
export * from "./IntentExamplesHeaderBulkDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports